import { TransportType, Status } from "../common";

export const TransportTypeLabels: Record<TransportType, string> = {
  [TransportType.CAR]: "Voiture",
  [TransportType.SCOOTER]: "Moto",
  [TransportType.BIKE]: "Vélo",
};

export interface Rider {
  _id: string;
  phone: string;
  transportType: TransportType;
  status: Status;
  fullName: string;
}

export interface RiderDetails {
  _id: string;
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  phone: string;
  city: string;
  coordinates?: number[];
  address: {
    street: string;
    zipCode: string;
    city: string;
  };
  transportType: TransportType;
}

export type IWriteRider = Omit<RiderDetails, "_id" | "password">;
